import React, { Component } from 'react';
import { connect } from 'react-redux';
import anime from 'animejs';
import dataModel from '../../models/DataModel';
import SupportButton from '../../assets/images/support-button.svg';
import zendeskSent from '../../assets/images/zendesk-sent.svg';
import TextMap from '../../helpers/TextMap';
import Metadata from '../../helpers/metadata/Metadata';
import './SupportForm.scss';
import ImageTools from '../../helpers/ImageTools';
import TrashIcon from '../../assets/images/trash.svg';
import Input from '../Input';
import Textarea from '../Textarea';

class SupportForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nameInput: '',
      emailInput: '',
      phoneInput: '',
      attachment: [],
      descriptionInput: '',
      messageSent: false,
      isExpanded: props.mobileBridge.isMobile || props.initializeExpanded,
      isApiFetching: false,
      isValidEmail: true,
      isValidPhone: true,
      isAttachmentVisible: false,
      updatedAttachmentList: [],
    };
    this.textMap = new TextMap();

    this.createFormSentDisplay = this.createFormSentDisplay.bind(this);
    this.expandOrContractForm = this.expandOrContractForm.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
    this.showAttachmentPopup = this.showAttachmentPopup.bind(this);
    this.handleCloseAttachmentPopup = this.handleCloseAttachmentPopup.bind(this);
    this.handleSaveAttachmentPopup = this.handleSaveAttachmentPopup.bind(this);
    this.removeAttachment = this.removeAttachment.bind(this);
    this.handleAddAttachment = this.handleAddAttachment.bind(this);
  }

  componentDidMount() {
    const { currentUser, initializeExpanded } = this.props;
    if (currentUser) {
      this.setState({
        nameInput: `${currentUser.first_name} ${currentUser.last_name}`,
        emailInput: currentUser.email,
      });
    }
    if (initializeExpanded) {
      let height = 456;
      let width = 300;
      anime({
        targets: '.support-form-content',
        height: height,
        width: width,
        easing: 'easeInOutCubic',
        duration: 200,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { currentUser, initializeExpanded } = this.props;
    const { attachment } = this.state;
    if (prevProps.currentUser != currentUser) {
      if (!currentUser) {
        this.setState({
          nameInput: '',
          emailInput: '',
          descriptionInput: '',
        });
      }
      else {
        this.setState({
          nameInput: `${currentUser.first_name} ${currentUser.last_name}`,
          emailInput: currentUser.email,
        });
      }
    }
    if (initializeExpanded != prevProps.initializeExpanded) {
      this.setState({ isExpanded: initializeExpanded });
      let height = 456;
      let width = 300;
      if (!initializeExpanded) {
        height = 0;
        width = 0;
      }
      anime({
        targets: '.support-form-content',
        height: height,
        width: width,
        easing: 'easeInOutCubic',
        duration: 200,
      });
    }

    if(attachment != prevState.attachment){
      this.setState({ updatedAttachmentList: attachment });
    }
  }

  async expandOrContractForm() {
    const { currentUser } = this.props;
    let height = 502;
    let width = 300;
    let delayExpansion = false;

    if (this.state.isExpanded) {
      let nameInput = currentUser ? `${currentUser.first_name} ${currentUser.last_name}` : '';
      let emailInput = currentUser ? currentUser.email : '';
      this.setState({ 
        messageSent: !this.state.messageSent,
        nameInput,
        emailInput,
        descriptionInput: '',
        phoneInput: '',
        attachment: [],
        isApiFetching: false,
      });
      if (this.props.onClose) {
        this.props.onClose();
      }
      height = 0;
      width = 0;
      delayExpansion = true;
      document.removeEventListener('click', this.handleClickOutside, false);
    }
    else {
      this.setState({ isExpanded: true, messageSent: false });   
      document.addEventListener('click', this.handleClickOutside, false);   
    }
    
    await anime({
      targets: '.support-form-content',
      height: height,
      width: width,
      easing: 'easeInOutCubic',
      duration: 200,
    }).finished;
    
    if (delayExpansion) {
      this.setState({ isExpanded: false, isAttachmentVisible: false });
    }
  }

  handleCancel() {
    const { mobileBridge } = this.props;
    if (mobileBridge.isMobile && this.props.history) {
      this.props.history.goBack();
    }
    else {
      this.expandOrContractForm();
    }
    if (this.props.onClose) {
      this.props.onClose();
    }

  }

  showAttachmentPopup(event){
    event.stopPropagation();
    document.removeEventListener('click', this.handleClickOutside, false);
    this.setState({ isAttachmentVisible: true, updatedAttachmentList: this.state.attachment });
  }

  handleAddAttachmentPopup(){
    document.getElementById('popupAddFile').click();
  }

  async handleAddAttachment(event) {
    const imageFiles = event.target.files;
    
    if (imageFiles && imageFiles.length > 0) {
      const attachments = await Promise.all([...imageFiles].map(image => this.resizeImage(image)));
      this.setState(prevState => ({
        updatedAttachmentList: [...prevState.updatedAttachmentList, ...attachments],
      }));
    }
  };

  handleCloseAttachmentPopup(){
    this.setState({ isAttachmentVisible: false });
    document.addEventListener('click', this.handleClickOutside, false);
  }

  removeAttachment(index){
    const { updatedAttachmentList } = this.state;
    const newAttachmentList = updatedAttachmentList.slice();
    newAttachmentList.splice(index, 1);
    this.setState({ updatedAttachmentList: newAttachmentList });
  }

  handleSaveAttachmentPopup(){
    this.setState({ attachment: this.state.updatedAttachmentList });
    this.handleCloseAttachmentPopup();
  }

  handleClickOutside(event) {
    if (this.formRef && !this.formRef.contains(event.target)) {
      this.expandOrContractForm();
    }
    if (this.props.onClose) {
      this.props.onClose();
    }

  }

  validateMobileNumber(mobileNumber){
    return /^\d{10}$/.test(mobileNumber) && mobileNumber !== '0000000000';
  };

  validateEmail(email) {
    return (email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  handleFormSubmit(e) {
    e.preventDefault();
    let isEmailValid = this.validateEmail(this.state.emailInput);
    let isPhoneValid = this.validateMobileNumber(this.state.phoneInput);
    
    this.setState({ isValidEmail: isEmailValid });
    this.setState({ isValidPhone: isPhoneValid });

    if (isEmailValid && isPhoneValid) {
      this.setState({ isApiFetching: true }, () => {
        if (this.props.onClose) {
          this.props.onClose();
        }
        const eventMetadatum = Metadata.generateMetadatum();
    
        let request = { 
          subject: this.textMap.zendeskSubject,
          email: this.state.emailInput,
          name: this.state.nameInput,
          message: this.state.descriptionInput + (this.state.zenDeskAdditionalInfo ? ' Additional info: ' + this.state.zenDeskAdditionalInfo : ''),
          version: process.env.VERSION ? process.env.VERSION : 'Running locally',
          device: eventMetadatum.device,
          phone: this.state.phoneInput,
          company: this.props.company && this.props.company.name ? this.props.company.name : '',
        };
        if(this.state.attachment){
          request.attachment = this.state.attachment;
        }
        dataModel.supportRequestsDAO.createSupportRequest(request, eventMetadatum).then(supportRequest => {
          const { currentUser } = this.props;
          let nameInput = currentUser ? `${currentUser.first_name} ${currentUser.last_name}` : '';
          let emailInput = currentUser ? currentUser.email : '';
          this.setState({ 
            messageSent: !this.state.messageSent,
            nameInput,
            emailInput,
            descriptionInput: '',
            phoneInput: '',
            attachment: [],
            isApiFetching: false,
          });
        }).catch(error => {
          // TODO:
        });
      });
    }
  }

  handleFormChange(e) {
    let value;
    let tempValue = e.target.value;

    if (e.target.name === 'phoneInput') {
      const cleanedValue = tempValue.replace(/\D/g, '');
      if (cleanedValue.length <= 10) {
        value = cleanedValue;
      } else {
        value = this.state.phoneInput;
      }
    } else {
      value = e.target.value;
    }

    this.setState({ [e.target.name]: value });
  }

  createFormSentDisplay() {
    return (
      <div className='support-form-container'>
        <div className='support-form-sent'>
          <img src={zendeskSent} alt="Sent"/>
          <p>Thank you for contacting us. We'll get back to you soon.</p>
        </div>
        <div className='support-form-buttons-cont support-form-buttons-cont--sent'>
          <button
            className='support-form-button support-form-button--submit-enabled'
            onClick={this.handleCancel}
            type='reset'
          >
            {this.textMap.done.toUpperCase()}
          </button>
        </div>
      </div>
    );
  }

  async onFileChange(event) {
    const imageFiles = event.target.files;
  
    if (imageFiles && imageFiles.length > 0) {
      const attachments = await Promise.all([...imageFiles].map(image => this.resizeImage(image)));
      this.setState(prevState => ({
        attachment: [...prevState.attachment, ...attachments],
      }));
    }
  };
  
  resizeImage(image) {
    return new Promise((resolve, reject) => {
      ImageTools.resize(image, {}, null, (convertedImage) => {
        const imgAttachment = {
          upload: convertedImage,
          name: convertedImage.name,
        };
        resolve(imgAttachment);
      });
    });
  };
 
  render() {
    const { mobileBridge } = this.props;
    const { messageSent, attachment, isAttachmentVisible, updatedAttachmentList } = this.state;

    const enableSave = this.state.descriptionInput && this.state.emailInput && this.state.phoneInput ? true : false;
    const disableClick = this.state.isApiFetching || !enableSave;

    let attachmentPopup;
    if(isAttachmentVisible){
      attachmentPopup = (
        <div className='support-attachment-background'>
          <div className='support-attachment-container'>
            <div className='support-attachment-header'>
              <div className='support-attachment-header__name'>ATTACHMENT</div>
              <input id="popupAddFile" className='support-attachment-input' multiple type="file" accept="image/png, image/jpeg" onChange={this.handleAddAttachment} onClick={(e) => e.stopPropagation()}/>
            </div>
            <div className='support-attachment-content'>
            {updatedAttachmentList && updatedAttachmentList.map((attachment, index) => (
              <div className='attachment-row' key={index}>
                <div className='attachment-row--name'>{attachment.name}</div>
                <img className='attachment-remove-button' src={TrashIcon} onClick={() => this.removeAttachment(index)} alt="Remove"/>
              </div>
            ))}
            </div>
            <div className='support-attachment-footer'>
              <div className='attachment-button'>
                <button className='attachment-button attachment-button--cancel' onClick={this.handleCloseAttachmentPopup}>CANCEL</button>
                <button className='attachment-button attachment-button--add' onClick={this.handleAddAttachmentPopup}>ADD</button>
                <button className='attachment-button attachment-button--save-enabled' onClick={this.handleSaveAttachmentPopup}>SAVE</button>
              </div>
            </div>
          </div>
        </div>
      );
    }
    else{
      attachmentPopup = <div></div>;
    }

    let content;
    if (messageSent) {
      content = this.createFormSentDisplay();
    }
    else {
      content = (
        <div className='support-form-container'>
          <div className='support-form-row support-form-row--name'>
            <label className='support-form-row__label'>Your name <span>(optional)</span></label>
            <Input
              className='support-form-row__input'
              name="nameInput"
              value={this.state.nameInput}
              onChange={this.handleFormChange}
            />
          </div>
          <div className='support-form-row support-form-row--email'>
            <label className='support-form-row__label'>Email Address*</label>
            <Input
              className='support-form-row__input'
              name="emailInput"
              value={this.state.emailInput}
              onChange={this.handleFormChange}
            />
            {
              this.state.isValidEmail
              ? null
              : (<span className='support-form-row__inputerror'>Enter valid email address</span>)
            }
          </div>
          <div className='support-form-row support-form-row--email'>
            <label className='support-form-row__label'>Mobile Number*</label>
            <Input
              className='support-form-row__input'
              name="phoneInput"
              type="number"
              value={this.state.phoneInput}
              onChange={this.handleFormChange}
            />
            {
              this.state.isValidPhone
              ? null
              : (<span className='support-form-row__inputerror'>Enter valid 10 digit mobile number.</span>)
            }         
          </div>
          <div className='support-form-row support-form-row--description'>
            <label className='support-form-row__label'>{this.textMap.zendeskHelpQuestion}*</label>
            <Textarea
              className='support-form-row__textarea'
              name="descriptionInput"
              placeholder={this.textMap.zendeskHelpMessage}
              value={this.state.descriptionInput}
              onChange={this.handleFormChange}
            />
          </div>
          <div className='support-form-row support-form-row--description'>
            <label className='support-form-row__label'>Attachment</label>
            <div className='support-form-row__attachment'>
              <label className="support-form-row__attachment__label" htmlFor="chooseFile">Choose File</label>
              <input id="chooseFile" className='support-form-row__attachment__input' multiple type="file" accept="image/png, image/jpeg" onChange={this.onFileChange} onClick={(e) => e.stopPropagation()}/>
              <span className={attachment && attachment.length != 0 ? 'support-form-row__attachment__fileName--link' : 'support-form-row__attachment__fileName'} onClick={attachment && this.showAttachmentPopup}>{attachment && attachment.length != 0 ? (attachment.length > 1 ? `${attachment.length} files` :  attachment[0] && attachment[0].name) : 'No file chosen'}</span>
            </div>
          </div>
          <div className='additional-info'>
            <h1 className='additional-info__header'>Additional Information</h1>
            {this.props.zenDeskAdditionalInfo ?
              <p className='additional-info__entry'>
                {'Stack Trace | ' + this.props.zenDeskAdditionalInfo}
                      </p>
              : <p className='additional-info__entry'>
                {`Application Version | ${process.env.VERSION ? process.env.VERSION : ''}`}
              </p>
            }
            {
              mobileBridge.isMobile && !this.zenDeskAdditionalInfo && 
              <p className='additional-info__entry'>
              { `Native Version Number | ${window.cordova ? (window.cordova.appVersion || '') : ''}` }
              </p>
            }
          </div>
          <div className='support-form-buttons-cont'>
            <button 
               className='support-form-button support-form-button--cancel'
              onClick={this.handleCancel}
              type='reset'
            >
              {this.textMap.cancel.toUpperCase()}
            </button>
            <button 
              disabled={disableClick}
              className={'support-form-button' + (enableSave ? ' support-form-button--submit-enabled' : ' support-form-button--submit-disabled')}
              type='submit'
            >
              {this.textMap.send.toUpperCase()}
            </button>
          </div>
        </div>
      );
    }

    return (
      <div ref={el => this.formRef = el}>
        {attachmentPopup}
      <div className='SupportForm'>
        <form 
          className='support-form-content' 
          onSubmit={this.handleFormSubmit}
          >
          { !mobileBridge.isMobile && <header>{this.textMap.support}</header> }
          { content }
        </form>
      { !this.state.isExpanded &&   
        <img className='support-button' src={SupportButton} onClick={this.expandOrContractForm} alt="Support"/>
        }
      </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let company = state.new_companies.currentCompany;
  if (company && state.new_companies[company.id]) {
    company = state.new_companies[company.id];
  }
  return {
    currentUser: state.new_users.currentUser,
    mobileBridge: dataModel.mobileBridge,
    company: company,
  };
};

export default connect(mapStateToProps)(SupportForm);



// WEBPACK FOOTER //
// ./src/components/SupportForm/index.js